import "core-js/modules/es.array.reverse.js";
var _class, _ArcGisPortalItemStratum, _class2, _ArcGisPortalItemReference;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import DOMPurify from "dompurify";
import i18next from "i18next";
import { computed, runInAction, makeObservable, override } from "mobx";
import { createTransformer } from "mobx-utils";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import AccessControlMixin from "../../../ModelMixins/AccessControlMixin";
import ReferenceMixin from "../../../ModelMixins/ReferenceMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ArcGisPortalItemFormatTraits from "../../../Traits/TraitsClasses/ArcGisPortalItemFormatTraits";
import ArcGisPortalItemTraits from "../../../Traits/TraitsClasses/ArcGisPortalItemTraits";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import CatalogMemberFactory from "../CatalogMemberFactory";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import StratumOrder from "../../Definition/StratumOrder";
export let ArcGisPortalItemStratum = (_class = (_ArcGisPortalItemStratum = class ArcGisPortalItemStratum extends LoadableStratum(ArcGisPortalItemTraits) {
  constructor(arcgisPortalItemReference, arcgisPortalCatalogGroup) {
    super();
    this.arcgisPortalItemReference = arcgisPortalItemReference;
    this.arcgisPortalCatalogGroup = arcgisPortalCatalogGroup;
    makeObservable(this);
  }
  duplicateLoadableStratum(_newModel) {
    return new ArcGisPortalItemStratum(this.arcgisPortalItemReference, this.arcgisPortalCatalogGroup);
  }
  static async load(arcgisPortalItemReference, arcgisPortalCatalogGroup) {
    if (arcgisPortalItemReference._arcgisItem === undefined) {
      if (arcgisPortalItemReference.uniqueId !== undefined) {
        arcgisPortalItemReference._portalRootUrl = arcgisPortalItemReference.url;
        arcgisPortalItemReference._arcgisItem = await loadPortalItem(arcgisPortalItemReference);
        arcgisPortalItemReference.setSupportedFormatFromItem(arcgisPortalItemReference._arcgisItem);
      }
    } else if (arcgisPortalCatalogGroup !== undefined) {
      arcgisPortalItemReference._portalRootUrl = arcgisPortalCatalogGroup.url;
    }
    return new ArcGisPortalItemStratum(arcgisPortalItemReference, arcgisPortalCatalogGroup);
  }
  get arcgisPortalItem() {
    if (this.arcgisPortalItemReference._arcgisItem === undefined) return undefined;
    return this.arcgisPortalItemReference._arcgisItem;
  }
  get portalItemUrl() {
    if (this.arcgisPortalItem === undefined || this.arcgisPortalItemReference._portalRootUrl === undefined) return undefined;
    const uri = new URI(this.arcgisPortalItemReference._portalRootUrl).segment("/home/item.html").addQuery("id", this.arcgisPortalItem.id);
    return uri.toString();
  }
  get url() {
    if (this.arcgisPortalItem === undefined) return undefined;
    if (this.arcgisPortalItem.type === "Scene Service") return "/i3s-to-3dtiles/".concat(this.arcgisPortalItem.url);
    return this.arcgisPortalItem.url;
  }
  get name() {
    if (this.arcgisPortalItem === undefined) return undefined;
    return this.arcgisPortalItem.title;
  }
  get description() {
    if (this.arcgisPortalItem === undefined) return undefined;
    // return this.arcgisPortalItem.description
    return DOMPurify.sanitize(this.arcgisPortalItem.description, {
      FORBID_ATTR: ["style"],
      FORBID_TAGS: ["font"]
    });
  }
  get info() {
    const outArray = [];
    if (this.arcgisPortalItem === undefined) return outArray;
    if (this.arcgisPortalItem.licenseInfo !== undefined) {
      outArray.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.arcgisPortal.licence"),
        content: DOMPurify.sanitize(this.arcgisPortalItem.licenseInfo, {
          FORBID_ATTR: ["style"],
          FORBID_TAGS: ["font"]
        })
      }));
    }
    outArray.push(createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcgisPortal.openInPortal"),
      content: "<a href=\"".concat(this.portalItemUrl, "\"><button>").concat(i18next.t("models.arcgisPortal.openInPortal"), "</button></a>")
    }));
    return outArray;
  }
}, _defineProperty(_ArcGisPortalItemStratum, "stratumName", "arcGisPortalDataset"), _ArcGisPortalItemStratum), _applyDecoratedDescriptor(_class.prototype, "arcgisPortalItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "arcgisPortalItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "portalItemUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "portalItemUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "url", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "url"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _class);
StratumOrder.addLoadStratum(ArcGisPortalItemStratum.stratumName);
let ArcGisPortalItemReference = (_class2 = (_ArcGisPortalItemReference = class ArcGisPortalItemReference extends AccessControlMixin(UrlMixin(ReferenceMixin(CreateModel(ArcGisPortalItemTraits)))) {
  get type() {
    return ArcGisPortalItemReference.type;
  }
  get typeName() {
    return i18next.t("models.arcgisPortal.name");
  }
  constructor(id, terria, sourceReference, strata) {
    super(id, terria, sourceReference, strata);
    _defineProperty(this, "_arcgisItem", undefined);
    _defineProperty(this, "_arcgisPortalCatalogGroup", undefined);
    _defineProperty(this, "_supportedFormat", undefined);
    _defineProperty(this, "_portalRootUrl", undefined);
    makeObservable(this);
    this.setTrait(CommonStrata.defaults, "supportedFormats", ArcGisPortalItemReference.defaultSupportedFormats);
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    } else if (isDefined(this._arcgisPortalCatalogGroup)) {
      return this._arcgisPortalCatalogGroup.cacheDuration;
    }
    return "0d";
  }
  get preparedSupportedFormats() {
    return this.supportedFormats && this.supportedFormats.map(prepareSupportedFormat);
  }
  isItemInSupportedFormats(item) {
    if (item === undefined) return undefined;
    for (let i = 0; i < this.preparedSupportedFormats.length; ++i) {
      const format = this.preparedSupportedFormats[i];
      // This is a bit clunky but format handling for non-Esri stuff in portal is a bit unpredictable
      if (format.formatRegex === undefined || format.urlRegex === undefined) {
        // eg KML we can match using format regex but not the URL
        if (format.formatRegex) {
          if (format.formatRegex.test(item.type)) return format;
        } else if (format.urlRegex) {
          if (format.urlRegex.test(item.url)) return format;
        }
      } else {
        if (format.formatRegex.test(item.type) && format.urlRegex.test(item.url)) {
          return format;
        }
      }
    }
    return undefined;
  }
  setDataset(item) {
    this._arcgisItem = item;
  }
  setArcgisPortalCatalog(arcgisCatalogGroup) {
    this._arcgisPortalCatalogGroup = arcgisCatalogGroup;
  }
  setSupportedFormatFromItem(item) {
    this._supportedFormat = this.isItemInSupportedFormats(item);
  }
  async setArcgisStrata(model) {
    const stratum = await ArcGisPortalItemStratum.load(this, this._arcgisPortalCatalogGroup);
    if (stratum === undefined) return;
    runInAction(() => {
      model.strata.set(ArcGisPortalItemStratum.stratumName, stratum);
    });
  }
  async forceLoadReference(_previousTarget) {
    // So when we first crawl we'll get this far
    await this.setArcgisStrata(this);
    // this.setSupportedFormatFromItem(this._arcgisItem);
    if (this._supportedFormat === undefined) return undefined;

    // See comments below re this sequence
    const itemDataInfo = await loadAdditionalPortalInfo(this);
    if (itemDataInfo !== undefined && this._arcgisItem !== undefined) {
      if (!itemDataInfo.error && itemDataInfo.layers) {
        if (itemDataInfo.layers.length === 1) {
          this._arcgisItem.url = "".concat(this._arcgisItem.url, "/").concat(itemDataInfo.layers[0].id);
        }
      }
      this.setSupportedFormatFromItem(this._arcgisItem);
    }

    // One final catch to handing types
    // Tiled MapServices dont use a single layer
    if (this._arcgisItem !== undefined && this._arcgisItem.type === "Map Service" && this._arcgisItem.typeKeywords.indexOf("Tiled") > -1) {
      const mapServerFormat = this.preparedSupportedFormats.filter(f => f.definition.type === "esri-mapServer");
      if (mapServerFormat.length === 1) this._supportedFormat = mapServerFormat[0];
    }
    const model = CatalogMemberFactory.create(this._supportedFormat.definition.type, this.uniqueId, this.terria, this);
    if (model === undefined) return;
    await this.setArcgisStrata(model);
    const defintionStratum = this.strata.get(CommonStrata.definition);
    if (defintionStratum) {
      model.strata.set(CommonStrata.definition, defintionStratum);
      model.setTrait(CommonStrata.definition, "url", undefined);
    }
    return model;
  }
}, _defineProperty(_ArcGisPortalItemReference, "defaultSupportedFormats", [createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "I3S",
  formatRegex: "Scene Service",
  urlRegex: "SceneServer$|SceneServer/$",
  definition: {
    type: "3d-tiles"
  }
}),
// createStratumInstance(ArcGisPortalItemFormatTraits, {
//   id: "WFS",
//   formatRegex: "WFS",
//   urlRegex: "WFSServer",
//   definition: {
//     type: "wfs"
//   }
// }),
createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "WMS",
  formatRegex: "WMS",
  urlRegex: "WMSServer",
  definition: {
    type: "wms"
  }
}), createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "ArcGIS MapServer Group",
  formatRegex: "Map Service",
  urlRegex: "MapServer$|MapServer/$",
  definition: {
    type: "esri-mapServer-group"
  }
}), createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "ArcGIS MapServer",
  formatRegex: "Map Service",
  urlRegex: /MapServer\/\d/,
  definition: {
    type: "esri-mapServer"
  }
}), createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "ArcGIS FeatureServer Group",
  formatRegex: "Feature Service",
  urlRegex: "FeatureServer$|FeatureServer/$",
  definition: {
    type: "esri-featureServer-group"
  }
}), createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "ArcGIS FeatureServer",
  formatRegex: "Feature Service",
  urlRegex: /FeatureServer\/\d/,
  definition: {
    type: "esri-featureServer"
  }
}), createStratumInstance(ArcGisPortalItemFormatTraits, {
  id: "Kml",
  formatRegex: "KML",
  definition: {
    type: "kml"
  }
})]), _defineProperty(_ArcGisPortalItemReference, "type", "arcgis-portal-item"), _ArcGisPortalItemReference), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "preparedSupportedFormats", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "preparedSupportedFormats"), _class2.prototype), _class2);
export { ArcGisPortalItemReference as default };
async function loadPortalItem(portalItem) {
  const uri = new URI(portalItem._portalRootUrl).segment("/sharing/rest/content/items/".concat(portalItem.itemId)).addQuery({
    f: "json"
  });
  const response = await loadJson(proxyCatalogItemUrl(portalItem, uri.toString(), portalItem.cacheDuration));
  return response;
}

// Portal has this weird habit of storing useful additional info about an item
// such as which layers to use from a group of layers at the /data endpoint
// But this only relevant on some layers
async function loadAdditionalPortalInfo(portalItem) {
  if (portalItem._arcgisItem === undefined) return undefined;
  const baseUrl = portalItem._portalRootUrl;
  const uri = new URI(baseUrl).segment("/sharing/rest/content/items/".concat(portalItem._arcgisItem.id, "/data")).addQuery({
    f: "json"
  });

  // The request also returns 200 even if the page is blank causing json errors
  // Sometimes it actually returns json containing an error, but not always
  try {
    const response = await loadJson(proxyCatalogItemUrl(portalItem, uri.toString(), portalItem.cacheDuration));
    return response;
  } catch (_err) {
    return undefined;
  }
}
const prepareSupportedFormat = createTransformer(format => {
  return {
    urlRegex: format.urlRegex ? new RegExp(format.urlRegex, "i") : undefined,
    formatRegex: format.formatRegex ? new RegExp(format.formatRegex, "i") : undefined,
    definition: format.definition || {}
  };
});